<template>
  <div class="groups-list">
    <div class="groups-list__title">Назначить права для пользователей</div>
    <div class="groups-list__groups">
      <div
        v-for="item in groups"
        :key="item.Id"
        class="groups-list__groups-item"
      >
        <div class="groups-list__groups-item-name">{{ item.Name }}</div>
        <app-icon
          v-if="!disabled"
          class="groups-list__groups-item-close"
          name="close-bold"
          width="12px"
          color="#979797"
          hover-color="#499259"
          cursor="pointer"
          @click="remove(item)"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

type ModalProps = {
  groups: any[];
  disabled: boolean;
};

const props = withDefaults(defineProps<ModalProps>(), { disabled: false });

const emit = defineEmits(["remove"]);

const remove = (item: any) => {
  emit("remove", item);
};
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

.groups-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  margin-top: 8px;

  &__title {
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: $color-text-secondary;
  }

  &__groups {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    position: relative;
    // gap: 4px;

    &-item {
      display: inline-flex;
      position: relative;
      padding: 1px 6px;
      height: 22px;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      gap: 1px;
      background: var(--Text-color-text-btn, #fff);
      box-shadow: 0 0 1px 0.5px #d2d2d2 inset;
      //   margin-top: 4px;
      //   margin-right: 4px;
      //   margin: 4px 0px 0px 4px;

      &-name {
        display: inline;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px;
        color: $color-text-secondary;
      }

      &-close {
        display: inline;
        // margin-left: 1px;
      }
    }
  }
}
</style>
